export const PARTNER_EMBEDDED_ADMIN = 'EMBEDDED_PARTNER_ADMIN';
export const ORGANIZATION_OWNER = 'ORGANIZATION_OWNER';

export function hasRole(user, roleName) {
  return Boolean(user?.roles?.includes(roleName));
}

export function isPartnerEmbeddedAdmin(user) {
  return hasRole(user, PARTNER_EMBEDDED_ADMIN);
}

export function isOrganizationOwner(user) {
  return hasRole(user, ORGANIZATION_OWNER);
}

/** Settings (team / integration) is limited to org owners and embedded partner admins. */
export function canAccessSettings(user) {
  return isOrganizationOwner(user) || isPartnerEmbeddedAdmin(user);
}

export function canManageNotificationSettings(user) {
  return isOrganizationOwner(user) || isPartnerEmbeddedAdmin(user);
}
